import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { APIRequest } from '../../../common/Common';
import { getTotal, sanitizeList } from '../../../common/Util';
import { TARGET_YEAR_API } from '../../../common/data';
// import { filterNonItemList } from './util';

const initialState = {
  isRender: false,
  reload: -1,
  detailReload: -1,
  dataList: [],
  //공제 불가 항목
  nonItemList: [],
  //원본데이터
  originalDataList: [],

  // 합계
  total: 0,
  //의료비 상세
  medicalDetail: [],

  selectedMedicalDetail: {},

  //급여
  salary: 0,
  initMedicalDetail: {
    fCnt: '',
    fStat: '0',
    htm001: '',
    htm002: '',
    htm006: '',
    htm007: '',
    htm016: '',
    htmCnt: 'E',
    htmKOFlag: '',
    htmPDFFlag: '',
    htmPDFSeq: '',
    htmPerBFlag: '',
    htmPerNm: '',
    htmPerRegNum: '',
    htmPerType: '',
    htmSeq: '',
    htmSilB: '',
    htmSilB2: '',
    htmPerBFlag: '',
    htmPerNm: '',
    htmSeq: '',
    htmSilB: '',
    htmSilB2: '',
  },
};

//의료비 불러오기
export const getMedicalInfo = createAsyncThunk('medical/getMedicalInfo', async () => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/S6`);
  return response;
});

//의료비 저장
export const updateMedicalInfo = createAsyncThunk('medical/updateMedicalInfo', async data => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/S6S1E`, data);
  return response;
});

//의료비 상세 불러오기
export const getMedicalDetail = createAsyncThunk('medical/getMedicalDetail', async data => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/S6S1`, data);
  return response;
});

//의료비 상세 삭제
export const deleteMedicalDetail = createAsyncThunk('medical/deleteMedicalDetail', async data => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/S6S1D`, data);
  return response;
});

const medicalSlice = createSlice({
  name: 'medicalSlice',
  initialState,
  reducers: {
    confirmDelete: (state, action) => {
      const { index } = action.payload;
      state.dataList = state.dataList.filter((_, idx) => idx !== index);
    },
    setSelectedMedicalDetail: (state, action) => {
      state.selectedMedicalDetail = action.payload;
    },
    setReload: (state, action) => {
      state.reload = Math.random();
    },
    setDetailReload: (state, action) => {
      state.detailReload = action.payload;
    },

    resetMedicalState: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(getMedicalInfo.pending, state => {
      // state.dataList = [];
      // state.nonItemList = [];
      state.isRender = false;
    });
    builder.addCase(getMedicalInfo.fulfilled, (state, action) => {
      console.log('의료비 리스트 >>', action.payload);
      const { list, htm013 } = action.payload;
      if (htm013) state.salary = htm013;
      else state.salary = 0;
      if (list) {
        state.dataList = list;
        //공제가능한 금액만 합계추출
        const totalList = list.filter(item => item.deType == '1');

        state.total = getTotal(totalList, [
          'glassSum',
          'standardSum',
          'glassOutsideSum',
          'standardOutsideSum',
        ]);
      } else {
        state.dataList = [];
        state.total = 0;
      }
      state.isRender = true;
    });

    builder.addCase(updateMedicalInfo.fulfilled, (state, action) => {
      console.log('의료비 저장 성공 >>', action.payload);
      const { resultCode } = action.payload;
      if (resultCode === 'OK') {
        state.reload = Math.random();
      }
    });

    builder.addCase(getMedicalDetail.fulfilled, (state, action) => {
      console.log('의료비 상세 성공 >>', action.payload);
      const { list } = action.payload;
      if (list) {
        state.medicalDetail = sanitizeList(list);
      } else {
        state.medicalDetail = [];
      }
    });

    builder.addCase(deleteMedicalDetail.fulfilled, (state, action) => {
      console.log('의료비 상세 삭제 성공 >>', action.payload);
      const { resultCode } = action.payload;
      if (resultCode === 'OK') {
        state.detailReload = Math.random();
      }
    });
  },
});

export const {
  confirmDelete,
  resetMedicalState,
  setSelectedMedicalDetail,
  setReload,
  setDetailReload,
} = medicalSlice.actions;
export default medicalSlice.reducer;
